<template>
  <div class="modal fade" :id="`CreatorModal${itemId}`" tabindex="-1" role="dialog" aria-labelledby="CreatorModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-body" style="padding: 0">
          <div class="row">
            <div class="col-md-6" :class="{'align-items-center':images.length===0, 'd-flex':images.length===0}">
              <p style="width: 100%" v-if="images.length===0 && video==null"><img :src="portrait" alt="" class="portrait-image"/></p>
              <p style="width: 100%" v-else-if="images.length===0 && video != null">
                <!--        <CloudflareVideoPlayer :video-id="video.content" :autoplay="true" />-->
                <iframe
                    :src="`https://iframe.videodelivery.net/${video.content}?enablejsapi=1`"
                    class="w-100" style="height: 60vh" id="cloudflare-video"
                    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                    webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
              </p>
              <vueper-slides fixed-height="90vh" v-else>
                <vueper-slide
                    v-for="(slide, i) in images"
                    :key="i"
                    :image="slide.image"
                >
                </vueper-slide>
              </vueper-slides>
            </div>
            <div class="col-md-6">
              <div class="post">
                <div class="post-header"><a class="post-author" href="#"><img :src="profile" alt=""/>
                  <div class="detail">

                    <div class="date">{{ time }}</div>
                  </div>
                </a>
                  <a class="more" href="#" @click.prevent="closeModal">
                    <icon icon="la-times-circle" :size="40" color="#5096ec"></icon>
                  </a>
                </div>
                <div class="post-content">
                  <p v-html="description"></p>
                </div>
                <div class="post-actions">
                  <a href="#">
                    <span>{{ likes }} </span> &nbsp;Like</a>
                  <a href="#">
                    <span>{{ comments }} </span> &nbsp;Comments</a>
                </div>

                <div class="comments">
                  <div class="comment" v-for="comment in postComments" :key="comment.id">
                    <img
                        src="/images/vue/image/avatar.jpeg"
                        alt="" class="comment__image">
                    <div class="comment__commentator">{{ comment.commentator.firstname }}
                      {{ comment.commentator.lastname }}
                    </div>
                    <div class="comment__comment">{{ comment.comment }}</div>
                    <div class="break"></div>
                    <div class="comment__time">{{ diffForHumans(comment.created_at) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {VueperSlide, VueperSlides} from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import TimeAgo from 'javascript-time-ago'

import en from 'javascript-time-ago/locale/en'
import Icon from "../../user/Icon";
import axios from "axios";

TimeAgo.addDefaultLocale(en)

export default {
  name: 'AppItemModal',
  props: ["itemId", "name", "title", "time", "profile", "description", "portrait", "likes", "comments", 'auth', "images", "postComments", "video"],
  components: {Icon, VueperSlides, VueperSlide},
  data() {
    return {
      commentText: "",
    }
  },

  methods: {
    diffForHumans(date) {
      const timeAgo = new TimeAgo('en-US')
      return timeAgo.format(new Date(date))
    },
    closeModal(){
      $(`#CreatorModal${this.itemId}`).modal('hide')
    },
  }
}
</script>
<style lang="scss" scoped>
.modal-content {
  background-color: #252d43;
}

.vueperslide, .vueperslide__image {
  height: 100%;

}

.post {
  padding: 20px 10px 2px 0;

  .post-content p {
    font-size: 12px;
  }

  .post-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 9px;

    .post-author {
      display: flex;
      align-items: center;

      img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .name {
        font-size: 13px;
        font-weight: bold;
        color: #f5f7fa;
      }

      .date,
      .job-title {
        font-size: 10px;
        color: #9ca3af;
      }

      .job-title {
        padding: 2px 0;
      }
    }
  }

  .post-actions {
    display: flex;
    padding-bottom: 20px;
    justify-content: space-between;

    a {
      font-size: 14px;
      color: #e5e7eb;
      margin-right: 15px;
      display: flex;
      align-items: center;
      transition: .2s;
      background-color: transparent;
      padding: 5px 10px;
      border-radius: 10px;

      &:hover {
        background-color: #2b354e;
      }

      svg {
        font-size: 20px;
        margin-right: 5px;
      }

      &:hover {
        color: var(--color);
      }
    }
  }

  .post-comment-form {
    display: flex;
    align-items: center;

    img {
      min-width: 32px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .textarea {
      flex: 1;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 8px;

      input {
        background: transparent;
        width: 100%;
        flex: 1;
        padding: 8px;
        border-radius: 40px;
        color: white;

        &::placeholder {
          color: #dedede;
        }
      }

      label {
        cursor: pointer;
        padding-left: 16px;
        font-size: 18px;
        color: #a7b4cc;
        padding-right: 5px;

        &:hover {
          color: var(--color);
        }

        input {
          display: none;
        }
      }
    }
  }
}

.comments {
  margin-top: 15px;
  max-height: 70vh;
  overflow: auto;

  .comment {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &__image {
      border-radius: 50%;
      width: 45px;
      margin-right: 10px;
    }

    &__commentator {
      font-weight: bold;
      letter-spacing: 1px;
      font-size: 13px;
      color: white;
      margin-right: 10px;
    }

    &__comment {
      font-size: 12px;
      margin-top: 2px;
    }

    &__time {
      margin-top: 6px;
      font-size: 12px;
      color: #9297a6;
    }
  }
}

.break {
  flex-basis: 100%;
  height: 0;
}

.portrait-image {
  min-height: 300px;
}
</style>
